<template>
  <unicom-linha class="unicom-linha linha-embaixo">
    <unicom-coluna sm="12">
      <unicom-linha justificarItem="center">
        <unicom-coluna sm="3" :class="espacamentoMobile">
          <div id="titulo">Quais tipos de especialidades oferece?</div>
        </unicom-coluna>
      </unicom-linha>
      <unicom-linha justificarItem="center" class="espaco">
        <unicom-coluna sm="5" :class="espacamentoMobile">
          <unicom-campo-texto
            ladoIcone="direito"
            :maxCaracteres="1500"
            clickIcone
            colorPlaceholder="#9E9E9E"
            placeholder="Especialidades Oferecidas"
            v-model="payload.especialidadesOferecidas"
          />
        </unicom-coluna>
      </unicom-linha>

      <unicom-linha justificarItem="center">
        <unicom-coluna sm="3" :class="espacamentoMobile">
          <div id="titulo">Número de Leitos de Observação?</div>
        </unicom-coluna>
      </unicom-linha>
      <unicom-linha justificarItem="center" class="espaco">
        <unicom-coluna sm="5" :class="espacamentoMobile">
          <custom-campo-texto
            ladoIcone="direito"
            clickIcone
            colorPlaceholder="#9E9E9E"
            placeholder="Número de Leitos"
            :apenasNumero="true"
            v-model="payload.numeroLeitosObservacao"
          />
        </unicom-coluna>
      </unicom-linha>
    </unicom-coluna>
  </unicom-linha>
</template>

<script>
import CustomCampoTexto from "@/views/RecursosPropriosQuestionarios/shared/CampoTexto/CampoTexto.vue";

import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    CustomCampoTexto
  },
  data() {
    return {
      payload: {
        tipoServico: "Pronto Socorro",
        numeroLeitosObservacao: "",
        especialidadesOferecidas: "",
        tipoServicoPublico: []
      }
    };
  },
  methods: {},
  watch: {
    "payload.numeroLeitosObservacao": "emitir",
    "payload.especialidadesOferecidas": "emitir",
    "payload.tipoServicoPublico": `emitir`,
    dadosServidor(newVal) {
      if (newVal.servicos.length > 0) {
        newVal.servicos.forEach(servico => {
          if (
            servico.tipoServico.tipoServico === this.payload.tipoServico &&
            (servico.tipoServicoPublico ||
              servico.especialidadesOferecidas ||
              servico.numeroLeitosObservacao)
          ) {
            this.clickSwitch = true;
            this.preencheCampo("publico", servico.tipoServicoPublico);
            this.preencheCampo(
              "especialidades oferecidas",
              servico.especialidadesOferecidas
            );
            this.preencheCampo("leitos", servico.numeroLeitosObservacao);
            this.emitPayload({
              ...this.payload,
              clickSwitch: this.clickSwitch
            });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.unicom-linha {
  margin-bottom: 24px;
}

.linha-embaixo {
  padding-bottom: 24px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 24px;
}

#titulo {
  font-size: 15px;
  padding-top: 8px;
  text-align: center;
}

.espaco {
  margin-top: 10px;
}
</style>
